import { Box, Container, Text, Title } from '@mantine/core';

// Shared page header band - the one consistent hero used by every secondary
// page (about, contact, contribute, findmybag, report, request, legal).
// Deliberately a server component (no 'use client'): purely presentational,
// and this lets server pages pass icon component references directly.
// Full-width gradient with the stud (noppen) texture, an icon bubble, a bold
// Montserrat title and a dimmed subtitle.
export function PageHero({ icon: Icon, iconColor = '#1971c2', iconBg = 'var(--bpb-blue-soft)', title, subtitle, children }) {
  return (
    <Box className="page-hero stud-overlay">
      <Container size="md" ta="center" style={{ padding: '48px 24px 40px' }}>
        {Icon && (
          <Box className="feature-icon-bubble" aria-hidden="true" style={{ backgroundColor: iconBg }}>
            <Icon size={34} color={iconColor} stroke={1.7} focusable="false" />
          </Box>
        )}
        <Title
          order={1}
          style={{
            color: 'var(--bpb-text)',
            fontWeight: 800,
            letterSpacing: '-0.5px',
            fontSize: 'clamp(26px, 4.5vw, 36px)',
            lineHeight: 1.2,
          }}
        >
          {title}
        </Title>
        {subtitle && (
          <Text c="dimmed" size="lg" maw={520} mx="auto" mt="xs">
            {subtitle}
          </Text>
        )}
        {children}
      </Container>
    </Box>
  );
}
